import { useParams } from "react-router-dom";
import ContainerTitulo from "../../../components/Formularios/Container/ContainerTitulo";
import FormTicket from "./formulario";

export function TicketVisualizar() {
  const idticket = useParams();
  return (
    <>
      <div className="container-fluid mt-2">
        <ContainerTitulo titulo={`Visualizar Ticket - [#${idticket.id}]`} />
        <FormTicket idticket={idticket.id} acao="Visualizar" />
      </div>
    </>
  );
} 